"use client";

import Link from "next/link";
import type { ComponentProps } from "react";
import { getMascot } from "@/components/mascot/registry";

type Props = Omit<ComponentProps<typeof Link>, "href"> & { href: string };

/**
 * An internal link that A carries you through: on a page change A drags the
 * cloth across, the route swaps behind it, and A hops onto the new page.
 * Same-page anchors, modified clicks and reduced motion fall through to Next.
 */
export function TLink({ href, onNavigate, ...rest }: Props) {
  return (
    <Link
      href={href}
      {...rest}
      onNavigate={(e) => {
        onNavigate?.(e);
        if (getMascot()?.navigate(href)) e.preventDefault();
      }}
    />
  );
}
